// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"354b5ff7","804":"703feff8"}[chunkId] + ".chunk.js";
};